<template>
    <span class="interval">
        <div class="interval-label main-text-color" v-if="label">
            {{ $t(label) }}
        </div>
        <el-input-number v-model="model" @input="onChange" :min="0" :placeholder="placeholder" :disabled="disabled"></el-input-number>
        <div class="el-form-item__error" v-show="isNotValidField && !isCondition">
          {{ $t('validation.error.fieldIsRequired') }}
        </div>
    </span>
</template>

<script>
import { InputNumber } from 'element-ui'

export default {
    components: {
        [InputNumber.name]: InputNumber, 
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: '' 
        },
        placeholder: {
            type: String,
            default: '' 
        },
        isRange: {
            type: Boolean,
            default: false
        },
        isClickedOnNextBtn: {
            type: Boolean,
            default: false
        },
        inputValue: {
            type: [Number, String]
        },
        isCondition: {
            type: Boolean,
            default: false
        },
        modelData: {
            type: Object,
            default: () => ({})
        }
    },
    watch: {
        model (val) {
            this.$emit('input', val)
        }
    },
    data () {
        return {
            model: 0
        }
    },
    mounted () {
        if (this.isCondition) {
            this.model = this.inputValue
        } else {
            const scheduleDataKey = 'ParameterTag' in this.$attrs ? this.$attrs.ParameterTag : this.$attrs.ComponentTag
            this.model = this.modelData[scheduleDataKey] !== undefined ? this.modelData[scheduleDataKey] : 0
        }
    },
    computed: {
        isNotValidField () {
            return this.isClickedOnNextBtn && !this.model
        }
    },
    methods: {
        onChange (val) {
            const data = {
                value: val,
                component: this.$attrs
            }
            this.$emit('change', data)
        }
    }
};
</script>

<style lang="scss" scoped>
.interval-label {
    @apply mb-2;
}
[dir="rtl"] .interval-label {
    @apply ml-3;
}
[dir="ltr"] .interval-label {
    @apply mr-3;
}
.el-form-item__error {
    @apply pt-2;
}
.interval {
    @apply relative;
}
::v-deep .el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled), ::v-deep .el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) {
    @apply border-primary;
}
</style>